
const faqConfig = {
  title: "Frequently Asked Questions",
  sections: [
    {
      title: "System Requirements",
      subsections: [
        {
          title: "Desktop or laptop computer (ideally less than three years old)",
          type: "list",
          content: [
            "PC operating system: Windows 7+; Apple operating system: OSX 10.6+",
            "Desktop web browser: preferably Google Chrome, Safari, or Firefox",
            "Webcam (most computers have a built-in webcam)",
            "Microphone (most computers have a built-in microphone)",
            "High-speed internet connection of at least 3.0 Mbps download / 1.0 Mbps upload",
          ],
        },
        {
          title: "Mobile",
          type: "list",
          content: [
            "An iOS device (iPhone 5s/iPad 4th generation) with the latest operating system updated (iOS 10+)",
            "An Android device (less than 2 years old) with at least Lollipop 5.1+",
          ],
        },
      ],
    },
    {
      title: "What is the Buoy LIVE service?",
      subsections: [
        {
          type: "paragraph",
          content: [
            "The Buoy LIVE service, powered by CirrusMD, allows users to discuss medical issues and questions with a doctor from the comfort of their own home, their place of work, or wherever they may be at that time. After registering, users will be granted access to a secure online platform,  assigned to a physician, and prompted to begin chatting about their medical concerns. The assigned doctor will typically respond within just a few minutes, will ask you questions, and, if medically indicated, may request to switch the conversation to video. When appropriate, the doctor may also call in certain prescriptions for you."
          ],
        },
      ],
    },
    {
      title: "Using Buoy LIVE for the first time",
      subsections: [
        {
          type: "list",
          content: [
            "There is a board-certified doctor on call from 7 AM to 9 PM Pacific / 8 AM to 10 PM Mountain, allowing you to receive health care from your desktop computer or mobile phone.",
            "After sending your initial message, stay online in order to chat with the doctor. Typical doctor response times are within just a few minutes.",
            "Always call 9-1-1 for medical emergencies. A medical emergency is an event that you reasonably believe threatens you or someone else’s life or limb in such a manner that immediate medical care is needed to prevent death or serious impairment of health. A medical emergency includes severe pain, bad injury, a serious illness, or a medical condition that is quickly worsening.",          ],
        },
      ],
    },
    {
      title: "Using Buoy LIVE at BuoyHealth.com",
      subsections: [
        {
          type: "list",
          content: [
            "When creating your account, ensure that you have correctly entered your profile information. Your credit card will be charged immediately, and you will then be brought into a Buoy LIVE session in a matter of seconds.",
            "Please do not click the back button or close your browser window during your Buoy LIVE session.",
          ],
        },
      ],
    },
    {
      title: "Can a doctor prescribe medication as part of a Buoy LIVE visit?",
      subsections: [
        {
          type: "paragraph",
          content: [
            "Yes. If the Buoy LIVE doctor believes that prescription medication is necessary for your treatment, the doctor will call in a prescription. The prescription will be sent directly to your preferred pharmacy for pick up at your convenience. Doctors are prohibited by law from calling in prescriptions for controlled substances.",
          ],
        },
        {
          title: "Can the doctor prescribe antibiotics?",
          type: "paragraph",
          content: [
            "Yes. When appropriate, the doctor can prescribe an antibiotic. CirrusMD doctors are committed to national guidelines on antibiotic stewardship, which were developed to promote the safe and appropriate use of antibiotics, improve outcomes, reduce microbial resistance, and decrease the spread of infections caused by multidrug-resistant organisms. Read the national guidelines here.",
          ],
        },
        {
          title: "Can the doctor prescribe controlled substances?",
          type: "paragraph",
          content: [
            "No. CirrusMD doctors do not prescribe controlled substances due to state and federal regulations governing prescribers and the safe use of certain medications with abuse potential. Please see your primary care doctor and/or specialists to discuss any issues requiring management with controlled substances.",
          ]
        }
      ],
    },
    {
      title: "What if I have a question about Buoy LIVE?",
      subsections: [
        {
          type: "paragraph",
          content: [
            "Please contact Buoy Health at support@buoyhealth.com for questions about Buoy LIVE.  For technical support, please contact support@cirrusmd.com.",
          ],
        },
      ],
    },
    {
      title: "Is Buoy LIVE safe and private?",
      subsections: [
        {
          type: "paragraph",
          content: [
            "Yes. Buoy LIVE is fully compliant with HIPAA (Health Insurance Portability and Accountability Act) standards. Your information will only be shared as appropriate with the physician, pharmacy, referring doctors or labs, Buoy Health, and CirrusMD.",
          ],
        },
      ],
    }, 
    {
      title: "Am I allowed to return to talk to a doctor free of charge?",
      subsections: [
        {
          type: "paragraph",
          content: [
            "Yes. You may return to your conversation with the doctor within the hours of 7 AM to 9 PM Pacific / 8 AM to 10 PM Mountain on the same day that you used the Buoy LIVE service.",
          ],
        },
      ],
    },
    {
      title: "Will I have access to my records after my visit?",
      subsections: [
        {
          type: "paragraph",
          content: [
            "Yes. Visit your Buoy Health profile page at buoyhealth.com/profile to access your past visits.",
          ],
        },
      ],
    },
    {
      title: "Have billing questions?",
      subsections: [
        {
          type: "paragraph",
          content: [
            "Please contact Buoy Health at support@buoyhealth.com.",
          ],
        },
      ],
    },
    {
      title: "What is CirrusMD?",
      subsections: [
        {
          type: "paragraph",
          content: [
            "CirrusMD is the country’s only Virtual Care Platform™ to provide a single access point for patient navigation and care delivery. Patients across the United States are able to gain instant access from their mobile phone or computer to the CirrusMD Provider Network of doctors, as well as to other clinical and non-clinical care resources, anytime they have a medical concern.",
          ],
        },
      ],
    },
  ],
}

export { faqConfig as default }



// WEBPACK FOOTER //
// ./assets/payment/components/faqConfig.js